<template>
  <div class="container-outer">
    <div class="topbar">
        <navbarComponent />
      </div>
    <div class="container-inner">
    <sidebarComponent />
    <div class="content">
      <div class="trendinggames">
        <gamesTab />
      </div>
    </div>
    
  </div>
  </div>
  
    
  </template>
  
  <script>
  import gamesTab from './gamesTab.vue'
  import sidebarComponent from '../../components/sidebar/sidebar.vue'
  import navbarComponent from '../../components/navbar/navbar.vue';

  export default {
    name: 'homeContent',
    data() {
      return {
      };
    },
    components: {
      gamesTab,
      sidebarComponent,
      navbarComponent
    },
    methods: {
      // Your methods go here
    },
    // Other component options (computed, watch, etc.) can be added here
  };
  </script>
  
  <style scoped>

  .content {
    display: flex;
  }

  .trendinggames {
    display: inline-flex;
    flex-direction: column;
    margin: 0 50px;
  }
  .topbar {
    position: sticky;
    top: 0;
    padding-bottom: 12px;
    
  }

  .container-inner {
    display: flex;
  }
  .container-outer {
    display: flex;
    flex-direction: column;
  }
  </style>
  